/* Hook encargado de crear el Cliente

Autor: Carolina Rojas
Fecha: 
*/
import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'
import Client from '../interfaces/Client.ts'

import { makeUrlClientCrea } from './connectionData.tsx'

const useClientCrea = () => {
  const [errorCreaClient, setErrorCreaClient] = useState<string | null>(null)
  const [loadingPost, setLoadingPost] = useState<boolean>(false)

  const creaClient = async (client: Client) => {
    setLoadingPost(true)

    try {
      const apiUrl = makeUrlClientCrea()

      console.log('URL:', apiUrl)
      console.log('Payload being sent:', client)

      const res = await customPost<{ _id: string }>(apiUrl, client)

      console.log('Response from API:', res)

      setErrorCreaClient(null)

      return res._id
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorCreaClient(err.message)
      } else {
        setErrorCreaClient('An unknown error occurred')
      }

      return null
    } finally {
      setLoadingPost(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorCreaClient, loadingPost, creaClient }
}
export default useClientCrea
